<script>
  import {helpStore} from '../../stores/help-store';

  export let buttonText;
  export let help;

  const onShowHelp = () => {
    helpStore.change(help);
    window.scrollTo(0, 0);
  };
</script>

<style>
</style>

<template lang="pug" src="./help-button.pug"></template>
